import { render } from "./ClinicIntegrationsTab.vue?vue&type=template&id=de5b84ea&scoped=true"
import script from "./ClinicIntegrationsTab.js?vue&type=script&lang=js&external"
export * from "./ClinicIntegrationsTab.js?vue&type=script&lang=js&external"

import "./ClinicIntegrationsTab.vue?vue&type=style&index=0&id=de5b84ea&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de5b84ea"]])

export default __exports__